import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"clock, time, timer"} maskId="square-filled-radius-0-stroke-1-IconClock"><path fillRule="evenodd" clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.5 7H11.5V12C11.5 12.1326 11.5527 12.2598 11.6464 12.3536L15 15.7071L15.7071 15L12.5 11.7929V7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconClock;
